import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { ReactComponent as Line } from "assets/images/iconsV2/line-vertical.svg";
import Dropdown from "components/v2/Dropdown/Dropdown";
import Pagination from "components/v2/Pagination/Pagination";
import "./Tablefooter.scss";

export interface TableFooterProps {
  itemsPerPage: number;
  setItemsPerPage: (value: number) => void;
  totalPages: number;
  currentPage: number;
  pageClicked: (page: any) => void;
  totalData: number;
}

function Tablefooter({ itemsPerPage, setItemsPerPage, totalPages, totalData, currentPage, pageClicked }: TableFooterProps) {
  const recordStart = (currentPage - 1) * itemsPerPage + 1;
  const recordEnd = Math.min(currentPage * itemsPerPage, totalData);

  const newTotalPages = Math.ceil(totalData / itemsPerPage);
  const adjustedCurrentPage = Math.min(currentPage, newTotalPages);

  // Update the current page if it has become invalid
  useEffect(() => {
    if (currentPage > newTotalPages && newTotalPages > 0) pageClicked(newTotalPages);
  }, [itemsPerPage, totalData, currentPage, newTotalPages, pageClicked]);

  const sizePerPageOptions = [
    { label: "10", value: 10 },
    { label: "25", value: 25 },
    { label: "100", value: 100 },
  ];

  return (
    <div className="table-footer-container d-flex justify-content-between">
      <div className="left d-flex text-sm text-secondary-v2">
        <div>
          {totalPages > 1 ? (
            <FormattedMessage
              id="components.organisms.listing.showTotalResultOf"
              defaultMessage="Showing {recordStart}-{recordEnd} of {pageCount} results"
              values={{ recordStart, recordEnd, pageCount: totalData }}
            />
          ) : (
            <FormattedMessage
              id="components.organisms.listing.showTotalResult"
              defaultMessage="Showing {length} of {pageCount} results"
              values={{ length: totalData, pageCount: totalData }}
            />
          )}
        </div>
        {totalData > 10 && (
          <div className="d-flex align-items-center">
            <Line className="ml-3xl mr-3xl" />
            <div className="d-flex align-items-center">
              <div className="mr-lg">Items per page</div>
              <Dropdown expandAbove options={sizePerPageOptions} value={itemsPerPage} onSelect={(e) => setItemsPerPage(e)} />
            </div>
          </div>
        )}
      </div>

      <div>
        <Pagination currentPage={adjustedCurrentPage} totalPages={newTotalPages} pageClicked={pageClicked} />
      </div>
    </div>
  );
}

export default Tablefooter;
